<template>
  <div class="cart">
    <base-loader v-if="isOrderCreating"></base-loader>
    <div class="page__title">{{ $t("cart.title") }}</div>
    <div class="cart__groups" v-if="clientGroups.length > 0">
      <div
        class="cart__group"
        v-for="group in clientGroups"
        :key="`client-${group.client.id}`"
      >
        <div class="cart__client-info">
          <div class="cart__client-info-title">
            {{ $t("cart.client_info.title") }}
          </div>
          <div class="cart__client-info-item">
            <div class="cart__client-info-item-title">
              {{ $t("cart.client_info.full_name") }}
            </div>
            <div class="cart__client-info-item-value">
              {{ group.client.full_name }}
            </div>
          </div>
          <div class="cart__client-info-item">
            <div class="cart__client-info-item-title">
              {{ $t("cart.client_info.inn") }}
            </div>
            <div class="cart__client-info-item-value">
              {{ group.client.inn }}
            </div>
          </div>
        </div>
        <table class="cart__table">
          <span class="cart__table-border"></span>
          <thead>
            <tr>
              <td>{{ $t("cart.table.created") }}</td>
              <td>{{ $t("cart.table.recipient") }}</td>
              <td>{{ $t("cart.table.payment_type") }}</td>
              <td>{{ $t("cart.table.count") }}</td>
              <td>{{ $t("cart.table.amount") }}</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              class="cart__item"
              v-for="cartItem in group.items"
              :key="`cart-item-${cartItem.id}`"
            >
              <td>
                <div class="cart__item-created">
                  <div class="cart__item-created-date">
                    {{ $moment(cartItem.created_at).format("DD.MM.YY") }}
                  </div>
                  <div class="cart__item-created-time">
                    {{ $moment(cartItem.created_at).format("hh:mm:ss") }}
                  </div>
                </div>
              </td>
              <td>
                <div class="cart__item-recipient">
                  {{
                    `${cartItem.payment_type_option.recipient} ${cartItem.payment_type_option.iban} ${cartItem.payment_type_option.okpo}`
                  }}
                  <br /><br />
                  {{ cartItem.purpose }}
                </div>
              </td>
              <td>
                <div class="cart__item-payment_type">
                  {{ $t(cartItem.payment_type.slug) }}
                </div>
              </td>
              <td>
                <div class="cart__item-count">
                  <div
                    class="cart__item-count-decrease"
                    @click="decreaseCartItemCount(cartItem)"
                  >
                    -
                  </div>
                  <div class="cart__item-count-value">
                    {{ cartItem.count }}
                  </div>
                  <div
                    class="cart__item-count-increase"
                    @click="increaseCartItemCount(cartItem)"
                  >
                    +
                  </div>
                </div>
              </td>
              <td>
                <div class="cart__item-amount">
                  {{ parseFloat(cartItem.sum_total) }}
                </div>
              </td>
              <td>
                <div class="cart__item-actions">
                  <div class="cart__item-action cart__item-action--complaint">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.25 7C13.25 8.38478 12.8005 9.66239 12.0393 10.6978C11.8854 10.9071 11.8711 11.128 11.8751 11.2472C11.8794 11.3735 11.9075 11.4848 11.9319 11.5637C11.9813 11.723 12.0599 11.8871 12.1351 12.0299C12.2057 12.164 12.2902 12.3103 12.3799 12.4598C12.2069 12.3665 12.0368 12.2783 11.8826 12.2061C11.7331 12.1362 11.5647 12.065 11.4036 12.0218C11.3236 12.0004 11.2149 11.9773 11.0937 11.9757C10.9815 11.9741 10.7726 11.9895 10.5709 12.1302C9.55887 12.8361 8.3289 13.25 7 13.25C3.54822 13.25 0.749999 10.4518 0.749999 7C0.749999 3.54822 3.54822 0.75 7 0.75C10.4518 0.75 13.25 3.54822 13.25 7Z"
                        stroke="#58ACFA"
                        stroke-width="1.5"
                      />
                      <path
                        d="M4.87686 5.12586C4.79698 5.04593 4.6866 5 4.57316 5C4.46015 5 4.34933 5.04593 4.26941 5.12586C4.18949 5.20582 4.14355 5.3166 4.14355 5.4296C4.14355 5.54304 4.18949 5.65343 4.26941 5.73331C4.34933 5.81323 4.46015 5.85921 4.57316 5.85921C4.6866 5.85921 4.79698 5.81323 4.87686 5.73331C4.95721 5.65343 5.00276 5.54261 5.00276 5.4296C5.00276 5.3166 4.95721 5.20578 4.87686 5.12586Z"
                        fill="#58ACFA"
                      />
                      <path
                        d="M9.0771 5.12586C8.99718 5.04593 8.88675 5 8.77335 5C8.66035 5 8.54953 5.04593 8.46961 5.12586C8.38973 5.20578 8.34375 5.3166 8.34375 5.4296C8.34375 5.54304 8.38973 5.65343 8.46961 5.73331C8.54953 5.81323 8.66035 5.85921 8.77335 5.85921C8.88675 5.85916 8.99718 5.81319 9.0771 5.73331C9.15698 5.65343 9.20296 5.54261 9.20296 5.4296C9.20296 5.3166 9.15702 5.20578 9.0771 5.12586Z"
                        fill="#58ACFA"
                      />
                      <path
                        d="M8.5715 9.01955C8.34218 8.16091 7.5616 7.56116 6.67348 7.56116C5.78536 7.56116 5.00483 8.16087 4.77542 9.01955C4.71414 9.24879 4.85035 9.48421 5.07959 9.54549C5.309 9.60693 5.54426 9.47051 5.60553 9.24131C5.73465 8.75796 6.17388 8.4204 6.67344 8.4204C7.17312 8.4204 7.61231 8.758 7.74139 9.24131C7.79269 9.43342 7.96633 9.56018 8.15616 9.56018C8.19286 9.56018 8.2302 9.55545 8.26732 9.54549C8.49661 9.48421 8.63277 9.24879 8.5715 9.01955Z"
                        fill="#58ACFA"
                      />
                    </svg>
                  </div>
                  <div
                    class="cart__item-action cart__item-action--delete"
                    @click="deleteItem(cartItem.id)"
                  >
                    <svg
                      width="14"
                      height="16"
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.0769 3.07694H9.99997C10 1.37753 8.62244 0 6.92306 0C5.22369 0 3.84612 1.37753 3.84612 3.07694H0.769219C0.344281 3.07694 0 3.42125 0 3.84616C0 4.27106 0.344312 4.61538 0.769219 4.61538H1.07691V14C1.07875 15.104 1.97291 15.9982 3.07691 16H10.7692C11.8732 15.9982 12.7674 15.104 12.7692 14V4.61538H13.0769C13.5018 4.61538 13.8461 4.27106 13.8461 3.84616C13.8461 3.42125 13.5018 3.07694 13.0769 3.07694ZM6.92306 1.53847C7.77259 1.53847 8.46153 2.22741 8.46153 3.07694H5.38459C5.38459 2.22738 6.07353 1.53847 6.92306 1.53847ZM11.2308 14C11.2308 14.2548 11.024 14.4615 10.7692 14.4615H3.07691C2.82212 14.4615 2.61538 14.2548 2.61538 14V4.61538H11.2308V14Z"
                        fill="#F27272"
                      />
                      <path
                        d="M5.23064 11.8463C4.80571 11.8463 4.46143 11.502 4.46143 11.0771V8.00017C4.46143 7.57524 4.80574 7.23096 5.23064 7.23096C5.65555 7.23096 5.99986 7.57527 5.99986 8.00017V11.0771C5.99989 11.502 5.65558 11.8463 5.23064 11.8463Z"
                        fill="#F27272"
                      />
                      <path
                        d="M8.61541 11.8463C8.19047 11.8463 7.84619 11.502 7.84619 11.0771V8.00017C7.84619 7.57524 8.1905 7.23096 8.61541 7.23096C9.04035 7.23096 9.38463 7.57527 9.38463 8.00017V11.0771C9.38463 11.502 9.04032 11.8463 8.61541 11.8463Z"
                        fill="#F27272"
                      />
                    </svg>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="cart__total">
          <div class="cart__total-title">
            {{ $t("cart.total.title", { itemsCount: group.items.length }) }}
          </div>
          <div class="cart__total-amount">
            {{ roundGroupSum(parseFloat(group.amount)) }} {{ $t("currency") }}
          </div>
        </div>
        <div class="cart__actions">
          <transparent-button
            class="cart__action"
            :text="$t('cart.action.add_payment')"
            @click="addPaymentToClient(group.client)"
          ></transparent-button>
          <primary-button
            mode="long"
            class="cart__action"
            :disabled="cartCreationClientId === group.client.id"
            :text="
              cartCreationClientId === group.client.id
                ? $t('loading')
                : $t('cart.action.pay')
            "
            @click="createOrder(group.client.id)"
          ></primary-button>
        </div>
      </div>
    </div>
    <div class="cart__empty" v-else>
      <primary-button
        class="cart__action"
        @click="toCreatePaymentPage"
        :text="$t('cart.action.create_payment')"
      ></primary-button>
      <transparent-button
        class="cart__action"
        :text="$t('cart.action.to_archive')"
        @click="toArchivePayments"
      ></transparent-button>
    </div>
    <select-widget-type-popup
      ref="selectWidgetTypePopup"
    ></select-widget-type-popup>
    <pay-order-qr-popup ref="payOrderQRPopup"></pay-order-qr-popup>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import { CartApi } from "@/office/cart/cart-api";
import { UPDATE_CART_ITEMS_COUNT } from "@/store/action-types";
import { OrderApi } from "@/office/order/order-api";
import {
  ADMIN_GOVERNMENT_PAYMENT,
  ADMIN_PAYMENT,
  REGISTRY_PAYMENT,
  REQUISITES_PAYMENT,
} from "@/const/payment-types";
import PayOrderQrPopup from "@/components/order/PayOrderQrPopup";
import SelectWidgetTypePopup from "@/components/order/SelectWidgetTypePopup.vue";
import BaseLoader from "@/components/base/BaseLoader.vue";
export default {
  name: "Cart",
  components: {
    BaseLoader,
    SelectWidgetTypePopup,
    PayOrderQrPopup,
    TransparentButton,
    PrimaryButton,
  },
  data() {
    return {
      isOrderCreating: false,
      clientGroups: [],
      cartCreationClientId: null,
      paymentTypesConst: {
        adminPayment: ADMIN_PAYMENT,
        registryPayment: REGISTRY_PAYMENT,
        requisitesPayment: REQUISITES_PAYMENT,
        adminGovernmentPayment: ADMIN_GOVERNMENT_PAYMENT,
      },
    };
  },
  created() {
    this.loadCart();
  },
  methods: {
    loadCart() {
      new CartApi().loadCart().then((r) => {
        this.clientGroups = r.data.groups;
        this.$store.dispatch(UPDATE_CART_ITEMS_COUNT, r.data.items_count);
      });
    },
    async createOrder(clientId) {
      this.cartCreationClientId = clientId;
      let widgetType = await this.$refs.selectWidgetTypePopup.open();

      if (!widgetType) {
        this.cartCreationClientId = null;
        return;
      }

      this.isOrderCreating = true;

      new OrderApi()
        .createOrder(clientId, widgetType)
        .then(async (r) => {
          this.loadCart();
          this.isOrderCreating = false;

          switch (widgetType) {
            case "qr": {
              await this.$refs.payOrderQRPopup.open(r.data.order.widget_url);
              this.$router.push({ name: "archive" });
              break;
            }
            case "pos": {
              window.open(r.data.order.widget_url, "_blank");
            }
          }
        })
        .finally(() => {
          this.cartCreationClientId = null;
          this.isOrderCreating = false;
        });
    },
    deleteItem(cartItemId) {
      new CartApi().deleteCartItem(cartItemId).then(() => {
        this.loadCart();
      });
    },
    addPaymentToClient(client) {
      this.$router.push({
        path: "/",
        query: {
          client: JSON.stringify(client),
        },
      });
    },
    toCreatePaymentPage() {
      this.$router.push("/");
    },
    toArchivePayments() {
      this.$router.push("/archive");
    },
    roundGroupSum(sum) {
      return Math.round((sum + Number.EPSILON) * 100) / 100;
    },
    async increaseCartItemCount(cartItem) {
      cartItem.count++;

      try {
        await new CartApi().updateCartItemCount(cartItem.id, cartItem.count);
        cartItem.sum_total = parseFloat(cartItem.sum_full) * cartItem.count;

        this.updateCartItemGroupAmount(cartItem);
      } catch (e) {
        cartItem.count--;
      }
    },
    async decreaseCartItemCount(cartItem) {
      if (cartItem.count === 1) {
        return false;
      }

      cartItem.count--;

      try {
        await new CartApi().updateCartItemCount(cartItem.id, cartItem.count);
        cartItem.sum_total = parseFloat(cartItem.sum_full) * cartItem.count;
        this.updateCartItemGroupAmount(cartItem);
      } catch (e) {
        cartItem.count++;
      }
    },
    updateCartItemGroupAmount(cartItem) {
      let clientGroup = this.clientGroups.find((_g) =>
        _g.items.find((_cI) => _cI.id === cartItem.id)
      );

      let cartItemsAmount = 0;

      clientGroup.items.forEach((item) => {
        cartItemsAmount += parseFloat(item.sum_total);
      });

      clientGroup.amount = cartItemsAmount;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.cart {
  margin-top: -50px;

  .page {
    &__title {
      margin-bottom: 26px;
    }
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  &__group {
    margin-bottom: 30px;
  }

  &__client-info {
    padding: 23px 32px;
    display: flex;
    align-items: center;
    border: 1px solid #f0f3fa;
    border-radius: 16px;

    &-title {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      margin-right: 25px;
    }

    &-item {
      display: flex;
      align-items: center;
      margin-right: 40px;

      &:last-child {
        margin-right: 0;
      }

      &-title {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $text;
        margin-right: 5px;
      }

      &-value {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $action;
      }
    }
  }

  &__table {
    position: relative;
    border-collapse: collapse;
    margin-top: 19px;

    &-border {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 1px solid #f0f3fa;
      border-radius: 16px;
      top: 0;
      left: 0;
      z-index: 0;
    }

    td {
      padding: 24px 32px;
      position: relative;
      z-index: 2;
    }

    thead {
      tr {
        background-color: #fafcfe;
        border-bottom: 1px solid #f0f3fa;
        td {
          color: $textLight;
          font-weight: 500;
          font-size: pxToRem(10);
          line-height: pxToRem(12);

          &:first-child {
            border-radius: 16px 0 0 0;
          }

          &:last-child {
            border-radius: 0 16px 0 0;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f0f3fa;

        &:last-child {
          border-bottom: none;

          td {
            &:first-child {
              border-radius: 0 0 0 16px;
            }

            &:last-child {
              border-radius: 0 0 16px 0;
            }
          }
        }
      }
    }
  }

  &__item {
    &-created {
      &-date {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        margin-bottom: 1px;
      }

      &-time {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        opacity: 0.6;
      }
    }

    &-recipient {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-payment_type {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-count {
      display: flex;
      align-items: center;
      justify-content: center;

      &-increase,
      &-decrease {
        font-size: pxToRem(20);
        line-height: pxToRem(20);
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      &-value {
        margin-left: 5px;
        margin-right: 5px;

        font-size: pxToRem(16);
        line-height: pxToRem(20);

        color: $action;
        font-weight: bold;
      }
    }

    &-amount {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
      font-weight: 700;
    }

    &-actions {
      display: flex;
      align-items: center;
    }

    &-action {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      cursor: pointer;
      transition: opacity 0.2s linear;

      &:hover {
        opacity: 0.8;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__total {
    padding: 32px;
    border: 1px solid #f0f3fa;
    border-radius: 16px;
    display: flex;
    align-items: center;
    margin-top: 20px;

    &-title {
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      color: $textLight;
      margin-right: 60px;
    }

    &-amount {
      font-weight: 600;
      font-size: pxToRem(16);
      line-height: pxToRem(20);
      color: $green;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-left: 140px;
    margin-top: 38px;
  }

  &__action {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
